module.exports = __webpack_public_path__ + "img/nominated.b35ca54e.jpg";